/** `promo` — promo assets for the gig (artwork, flyers, press kits, videos). */
import { z } from "zod";
import { defineCollection, field } from "../define.ts";

export const promo = defineCollection({
  key: "promo",
  labelKey: "collections.promo",
  icon: "image",
  sheetTab: "Promo",
  dedupFields: ["title", "asset_type"],
  sort: [{ field: "title" }],
  split: "gig",
  chatHint:
    "Promo assets: artwork, poster, flyer, banner, social clip, press kit, music, video, logo — " +
    "with status and where the asset lives.",
  fields: {
    title: field({
      type: z.string().min(1),
      tier: "hot",
      pii: "promoter",
      labelKey: "promo.title",
      sheet: { column: "Title" },
      description: "Asset name.",
    }),
    asset_type: field({
      type: z.string().optional(),
      tier: "hot",
      pii: "promoter",
      labelKey: "promo.asset_type",
      suggestedChips: ["artwork", "poster", "flyer", "banner", "social", "press kit", "video", "logo"],
      sheet: { column: "Type" },
      description: "artwork | poster | flyer | banner | social | press kit | music | video | logo.",
    }),
    status: field({
      type: z.enum(["needed", "in_progress", "delivered", "approved"]).optional(),
      tier: "hot",
      pii: "promoter",
      labelKey: "promo.status",
      sheet: { column: "Status" },
      description: "needed | in_progress | delivered | approved.",
    }),
    url: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "promoter",
      labelKey: "promo.url",
      sheet: { column: "URL" },
      description: "Where the asset lives (Drive link, WeTransfer…).",
    }),
    notes: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "promo.notes",
      sheet: { column: "Notes" },
      description: "Specs, deadlines, who delivers.",
    }),
  },
});
